import classNames from "classnames/bind";
import styles from "./Button.module.scss";

const cx = classNames.bind(styles);

function Button({
    title,
    style,
    leftIcon,
    rightIcon,
    isPrimary,
    isBorder,
    isRadius,
    classN,
    onClick,
    ...props
}) {
    const prop = { ...props, onClick };

    const classes = cx("wrapper", {
        [classN]: classN,
        isPrimary,
        isBorder,
        isRadius,
    });

    return (
        <button style={style} className={classes} {...prop}>
            {title}
        </button>
    );
}

export default Button;
